import { DEFAULT_LANGUAGE, LANGUAGE, LOCALE } from '@/lib/constants/i18n';
import { Translations } from '@/lib/types/translations';

export const getLangFromLocale = (locale: LOCALE) =>
  (locale.split('-').shift() as LANGUAGE) || DEFAULT_LANGUAGE;

export const getTranslations = <T extends Translations, L extends keyof T>(
  translations: T,
  lang: L,
): T[typeof DEFAULT_LANGUAGE] => ({
  ...translations[DEFAULT_LANGUAGE],
  ...translations[lang],
});
